enum ProductDocumentSignerSource {
  'contract.client.email' = 'contract.client.email',
  'contract.createdBy.email' = 'contract.createdBy.email',
}
export default ProductDocumentSignerSource;
